<mat-form-field #formFieldContainer floatLabel="always" class="avl-speed-wrapper">
    <mat-label
      #labelContainer  (click)="toggleTooltip(tooltip)"
      class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
      {{componentDefinition?.label}}
    </mat-label>
    <div class="labelToolTipContainer"
         #tooltip="matTooltip"
         matTooltip="{{componentDefinition.label}}"
         [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
    </div>
    <input matInput hidden />
    <div style="width: 100%; height: 100%;  overflow: hidden;" [style.height.px]="mapHeight">
        <div #targetMap [id]="fieldName+'map'" class="map" style="width:100%; height:100%;position: relative;">
            <div #info id="info" class="popover"
                [style.left]="infoPosition.left" [style.top]="infoPosition.top"
                [style.display]="isPopoverOpen? 'table': 'none'">
                <div class="popover-inner">
                    <div #tooltipInfo class="popover-content"></div>
                </div>
            </div>
        </div>
    </div>
</mat-form-field>
